<template>
  <div class="specialty-list-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">特色专科</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <aside class="sidebar">
        <div class="sidebar-section">
          <ul class="category-list">
            <li v-for="(dept, index) in specialties" :key="dept.id" class="tree-item">
              <div class="tree-row">
                <span class="expand-icon empty"></span>
                <a href="#" @click.prevent="selectSpecialty(index, dept)" 
                   :class="{ active: activeTab === index }">
                  {{ dept.name }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </aside>

      <main class="main-layout">
        <div class="specialty-content" v-if="currentSpecialty">
          <h2 class="dept-title">{{ currentSpecialty.name }}</h2>
          
          <div v-if="articles.length > 0" class="article-list">
            <div 
              v-for="article in articles" 
              :key="article.id" 
              class="article-item"
              @click="goToDetail(article)"
            >
              <div class="article-image" v-if="article.image">
                <img :src="article.image" :alt="article.title" />
              </div>
              <div class="article-content">
                <h3 class="article-title">{{ article.title }}</h3>
                <div class="article-meta">
                  <span class="meta-date">{{ article.date ? article.date.substring(0, 10) : '' }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div v-else class="no-article-tip">该栏目暂无文章</div>
          
          <div class="pagination" v-if="totalPages > 1">
            <button class="page-btn" :disabled="currentPage === 1" @click="prevPage">上一页</button>
            <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
            <button class="page-btn" :disabled="currentPage >= totalPages" @click="nextPage">下一页</button>
          </div>
        </div>
        <div v-else class="loading-state">
          加载中...
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SpecialtyList',
  data() {
    return {
      activeTab: 0,
      specialties: [],
      currentSpecialty: null,
      flatCategories: [],
      specialtyCategoryId: null,
      articles: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      totalItems: 0
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get('/api/categories')
        if (response.data && response.data.flat) {
          this.flatCategories = response.data.flat
          var specCat = null
          for (var i = 0; i < this.flatCategories.length; i++) {
            if (this.flatCategories[i].name === '特色专科') {
              specCat = this.flatCategories[i]
              break
            }
          }
          if (specCat) {
            this.specialtyCategoryId = specCat.id
            this.specialties = []
            for (var j = 0; j < this.flatCategories.length; j++) {
              if (this.flatCategories[j].parent === specCat.id) {
                this.specialties.push(this.flatCategories[j])
              }
            }
          }
          if (this.specialties.length > 0) {
            this.selectSpecialty(0, this.specialties[0])
          }
        }
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    selectSpecialty(index, dept) {
      this.activeTab = index
      this.currentSpecialty = dept
      this.currentPage = 1
      this.fetchArticles()
    },
    async fetchArticles() {
      if (!this.currentSpecialty) return
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          category_id: this.currentSpecialty.id
        }
        const response = await axios.get('/api/posts', { params })
        if (response.data.success) {
          this.articles = response.data.data || []
          this.totalItems = response.data.total || this.articles.length
          this.totalPages = Math.ceil(this.totalItems / this.pageSize)
        }
      } catch (error) {
        console.error('获取文章失败:', error)
        this.articles = []
      }
    },
    goToDetail(article) {
      if (article.external_link) {
        window.open(article.external_link, '_blank')
        return
      }
      const id = typeof article === 'object' ? (article.id || article.ID) : article
      if (id) {
        this.$router.push('/article/' + id)
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchArticles()
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.fetchArticles()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.specialty-list-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 144px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 300px;
  flex-shrink: 0;
  position: sticky;
  top: 175px;
  align-self: flex-start;
}

.sidebar-section {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li.tree-item {
    border-bottom: 1px dashed #eee;

    &:last-child {
      border-bottom: none;
    }

    .tree-row {
      display: flex;
      align-items: center;
      padding: 6px 0;

      .expand-icon {
        cursor: pointer;
        font-size: 8px;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        color: #4ecdc4;

        &.empty {
          cursor: default;
          color: transparent;
        }
      }

      a {
        flex: 1;
        font-size: 14px;
        color: #666;
        text-decoration: none;

        &:hover, &.active {
          color: #4ecdc4;
          font-weight: bold;
        }
      }
    }
  }
}

.main-layout {
  flex: 1;
}

.loading-state {
  text-align: center;
  padding: 80px 0;
  color: #999;
  font-size: 16px;
}

.specialty-content {
  flex: 1;
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dept-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.article-list {
  .article-item {
    display: flex;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;

    &:hover {
      background: #f9f9f9;
    }

    &:last-child {
      border-bottom: none;
    }

    .article-image {
      width: 120px;
      height: 80px;
      flex-shrink: 0;
      margin-right: 15px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
      }
    }

    .article-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .article-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin: 0;
        line-height: 1.4;
      }

      .article-meta {
        .meta-date {
          font-size: 13px;
          color: #999;
        }
      }
    }
  }
}

.no-article-tip {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 16px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px 0;

  .page-btn {
    padding: 10px 20px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
    color: #333;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .page-info {
    font-size: 14px;
    color: #666;
  }
}
</style>
